var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 113,
    viewBox: "0 0 285 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.309122 0.226316L0.309113 112.691L284.263 112.691C283.166 112.424 282.07 112.155 280.974 111.887C272.227 109.745 263.505 107.609 254.596 106.063C238.914 103.372 223.793 99.8255 208.487 96.2352C205.37 95.504 202.245 94.771 199.106 94.0431C195.764 93.2655 192.393 92.5267 189.018 91.7871C177.636 89.2931 166.216 86.7907 155.789 82.7642C149.072 80.1819 142.266 77.7192 135.465 75.258C127.498 72.3751 119.537 69.4944 111.731 66.4261C110.127 65.7961 108.497 65.2093 106.857 64.6188C103.589 63.4423 100.28 62.2509 97.0529 60.6739C92.7657 58.5786 90.8193 56.3699 88.3404 53.5569C88.0171 53.19 87.6847 52.8128 87.3368 52.4242C80.46 44.9794 71.9111 38.3483 62.015 32.7829C59.2029 31.1452 56.614 29.3361 54.0325 27.5322C51.4837 25.7512 48.9422 23.9752 46.2004 22.3742C42.5212 20.1695 38.7055 18.0634 34.8884 15.9566C30.8387 13.7214 26.7874 11.4853 22.8959 9.12965C19.0924 6.8342 10.3973 3.67091 0.309122 0.226316Z",
    fill: "#0C1217"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerLeft);
export default __webpack_public_path__ + "static/media/corner_left.ebaab64e6a1b6d33c73718cbd9b9bb21.svg";
export { ForwardRef as ReactComponent };